var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAbPageIcon04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 52,
    viewBox: "0 0 55 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M26.5195 7.38945C26.9976 6.71194 28.0024 6.71194 28.4805 7.38945L49.9807 37.8581C50.5416 38.653 49.9731 39.75 49.0002 39.75H5.99977C5.02687 39.75 4.45837 38.653 5.0193 37.8581L26.5195 7.38945Z",
    fill: "#cf3d31"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7656 27.6875C42.8324 27.6875 42.0781 26.9315 42.0781 26C42.0781 17.8578 35.4547 11.2344 27.3125 11.2344C19.1703 11.2344 12.5469 17.8578 12.5469 26C12.5469 26.9315 11.7926 27.6875 10.8594 27.6875C9.92619 27.6875 9.17188 26.9315 9.17188 26C9.17188 15.9965 17.309 7.85938 27.3125 7.85938C37.316 7.85938 45.4531 15.9965 45.4531 26C45.4531 26.9315 44.6988 27.6875 43.7656 27.6875Z",
    fill: "#0e131c"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29 26.3105V20.9375C29 20.006 28.2457 19.25 27.3125 19.25C26.3793 19.25 25.625 20.006 25.625 20.9375V26.3105C23.6658 27.0091 22.25 28.8654 22.25 31.0625C22.25 33.8536 24.5214 36.125 27.3125 36.125C30.1036 36.125 32.375 33.8536 32.375 31.0625C32.375 28.8654 30.9592 27.0091 29 26.3105ZM27.3125 32.75C26.381 32.75 25.625 31.9923 25.625 31.0625C25.625 30.1327 26.381 29.375 27.3125 29.375C28.244 29.375 29 30.1327 29 31.0625C29 31.9923 28.244 32.75 27.3125 32.75Z",
    fill: "#0e131c"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3125 51.3125C13.3552 51.3125 2 39.9573 2 26C2 12.0427 13.3552 0.6875 27.3125 0.6875C41.2698 0.6875 52.625 12.0427 52.625 26C52.625 39.9573 41.2698 51.3125 27.3125 51.3125ZM27.3125 4.0625C15.2165 4.0625 5.375 13.904 5.375 26C5.375 38.096 15.2165 47.9375 27.3125 47.9375C39.4085 47.9375 49.25 38.096 49.25 26C49.25 13.904 39.4085 4.0625 27.3125 4.0625Z",
    fill: "#0e131c"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbPageIcon04);
export default __webpack_public_path__ + "static/media/ab-page-icon04.60d048ac21c811827061838e7599d6c1.svg";
export { ForwardRef as ReactComponent };